// src/components/MainContent.jsx
import { useState, useEffect } from 'react';
import '../styles/MainContent.css';
import About from './About';
import Login from './Login';
import Profile from './Profile';
import LoadingPage from './LoadingPage';

export default function MainContent({ page, setPage, user, setUser }) {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  const role = user?.role;

  useEffect(() => {
    if (page === 'about' || page === 'login' || page === 'profile') {
      setLoading(false);
      return;
    }

    setLoading(true);
    setFadeOut(false);

    const timer = setTimeout(() => {
      setFadeOut(true); 
      setTimeout(() => setLoading(false), 500); 
    }, 4000);

    return () => clearTimeout(timer);
  }, [page]);

  const canEdit = (targetPage) => {
    if (role === 'admin' || role === 'operator') return true;

    switch (role) {
      case 'operator_Pharma':
        return targetPage === 'home';
      case 'operator_Mfg':
        return targetPage === 'manufacturing';
      case 'operator_Powerplant':
        return targetPage === 'powerplant';
      default:
        return false;
    }
  };

  const renderIframe = (src, targetPage) => {
    const isEditable = canEdit(targetPage);
    return (
      <div className="iframe-wrapper">
        <iframe
          src={src}
          className="iframe-full"
          title="External Page"
          style={{ display: loading ? 'none' : 'block' }}
        ></iframe>
        {!isEditable && !loading && (
          <div className="iframe-overlay">
            <p className="overlay-text">🔒 View-only access</p>
          </div>
        )}
      </div>
    );
  };

  const renderContent = () => {
    switch (page) {
      case 'home': // Pharma
        return renderIframe("/webvisu/aiotics.htm", "home");
      case 'manufacturing':
        return renderIframe("/manufacturing/aioticsmfg.htm", "manufacturing");
      case 'powerplant':
        return renderIframe("/iotdemo/iotdemo.htm", "powerplant");
      case 'dashboard':
       return renderIframe("/dashboard/", "dashboard");
      case 'about':
        return <About />;
      case 'login':
        return <Login setPage={setPage} user={user} setUser={setUser} />;
      case 'profile':
        return <Profile user={user} onLogout={() => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          setUser(null);
          setPage('login');
        }} />;
      default:
        return <p>Page not found</p>;
    }
  };

  return (
    <main className="main-content">
      {loading && (
        <div className={`loading-overlay ${fadeOut ? 'fade-out' : ''}`}>
          <LoadingPage />
        </div>
      )}
      {renderContent()}
    </main>
  );
}
